goog.provide("shadow.js.shim.module$$mui$material$ListItemIcon$default");
shadow.js.shim.module$$mui$material$ListItemIcon$default = shadow.js.shim.module$$mui$material$ListItemIcon.default;
